import {SWIPER_AUTO} from '../constants';

const
  NAME                 = 'initSwiperOnTab',
  VERSION              = '1.0.0',
  JQUERY_NO_CONFLICT   = $.fn[NAME]
;

class InitSwiperOnTab {
  constructor(element$) {
    var tabButtons$ = element$.find('a[data-toggle="tab"]');
    tabButtons$.on('shown.bs.tab', this.onShowTab.bind(this));
  }

  onShowTab(event) {
    var activeTabPan$ = $(event.target).attr('href');
    var swiperContainer$ = $(activeTabPan$).find('.swiper-container');
    if(swiperContainer$.length) {
      swiperContainer$.data('swiper', swiperContainer$.swiper(Object.create(SWIPER_AUTO)));
    }
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface() {
    return this.each(function() {
      new InitSwiperOnTab($(this));
    });
  }
}

$.fn[NAME]             = InitSwiperOnTab._jQueryInterface;
$.fn[NAME].Constructor = InitSwiperOnTab;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return InitSwiperOnTab._jQueryInterface;
};

export default InitSwiperOnTab;



// WEBPACK FOOTER //
// ./src/plugins/init-swiper-on-tab.js